import { Stack } from "@mantine/core";

import { NoticeDisplayType } from "src/api/Tmd.dtos";
import useNoticesContext from "src/hooks/notices/useNoticesContext";

import NoticeAlert from "./NoticeAlert";

/**
 * Renders banner-display notices in context order with banner styling.
 * Postconditions: No matches render nothing; each banner forwards context actions unchanged.
 * Assumptions: Context owns eligibility and dismissal state; this component does not acknowledge itself.
 */
const NoticeBanners = () => {
    const { notices, acknowledge, dismiss } = useNoticesContext();
    const banners = notices.filter(notice => notice.displayOption === NoticeDisplayType.Banner);
    if (banners.length === 0) {
        return null;
    }

    return (
        <Stack
            gap={0}
            data-notice-banner-stack
        >
            {banners.map(notice => (
                <NoticeAlert
                    key={notice.id}
                    notice={notice}
                    onAcknowledge={acknowledge}
                    onDismiss={dismiss}
                    banner
                />
            )
            )}
        </Stack>
    );
};

export default NoticeBanners;
